import * as classnames from 'classnames';
import * as React from 'react';
import styled, { css } from 'styled-components';
import { Header, HeaderLabel } from './AccordionStyle';
import { Column } from '@estee/elc-grid';
import { AccordionIcons } from './AccordionIcons';

export interface ILabelDetailSlideProps {
    id: string;
    title: string;
    extrainfo: string;
    className?: string;
    index?: number;
    isOpen?: boolean;
    iconType?: string;
    dataTestId?: string;
    onChange?(openIndex: number): void;
    headerBackgroundColor?: string;
}

const LabelDetailDiv = styled.div`
    margin-left: auto;

    [dir='rtl'] & {
        margin-left: 8px;
        margin-right: auto;
    }
`;

const iconCss = css`
    margin-left: 10px;
    min-width: 16px;

    [dir='rtl'] & {
        margin-right: 8px;
    }
`;

const AccordionIconsStyled = styled(AccordionIcons)`
    ${iconCss};
`;

const HeaderWrapper = styled(Header)<{ backgroundColor?: string }>`
    background-color: ${({ backgroundColor }) => `#${backgroundColor}` || 'transparent'};
    border: 1px solid;
`;

export class LabelDetailSlide extends React.Component<ILabelDetailSlideProps> {
    constructor(props: ILabelDetailSlideProps) {
        super(props);
        this.onClick = this.onClick.bind(this);
        this.handleHeaderKeyboardAccess = this.handleHeaderKeyboardAccess.bind(this);
    }

    private onClick(): void {
        if (this.props.onChange) {
            this.props.onChange(this.props.index || 0);
        }
    }

    private handleHeaderKeyboardAccess(event: React.KeyboardEvent<HTMLDivElement>): void {
        if (event.key === 'Enter' || event.key === ' ') {
            this.onClick();
        }
    }

    private dislayContent() {
        if (this.props.isOpen) {
            return (
                <Column className="elc-radio-slide-content js-radio-slide-content">
                    {this.props.children}
                </Column>
            );
        }

        return null;
    }

    public render() {
        const labelSlideClass = classnames(
            this.props.className,
            'elc-label-slide',
            'js-label-slide'
        );

        const isOpen: boolean = this.props.isOpen || false;

        return (
            <div className={labelSlideClass}>
                <HeaderWrapper
                    onClick={this.onClick}
                    onKeyPress={this.handleHeaderKeyboardAccess}
                    title={this.props.title}
                    tabIndex={0}
                    role="tab"
                    data-test-id={this.props.dataTestId || ''}
                    aria-controls={`acc-${this.props.id}`}
                    aria-expanded={isOpen}
                    className="elc-accordion-header js-accordion-header"
                    isOpen={isOpen}
                    backgroundColor={this.props.headerBackgroundColor}
                >
                    <HeaderLabel className="elc-header-label js-header-label">
                        {this.props.title}
                    </HeaderLabel>
                    <AccordionIconsStyled
                        isOpen={this.props.isOpen}
                        iconType={this.props.iconType}
                    />
                    <LabelDetailDiv className="elc-label-detail js-label-detail">
                        {this.props.extrainfo}
                    </LabelDetailDiv>
                </HeaderWrapper>
                {this.dislayContent()}
            </div>
        );
    }
}
